import { mapActions, mapState } from 'vuex';
import { formMixin, validators } from '@/components/forms/mixin';

const CAPTCHA_FIELD = 'g-recaptcha-response';

export default {
  mixins: [
    formMixin,
  ],
  data() {
    return {
      // login attempt counter used to rerender captcha on failed login
      attempt: 1,
      fields: {
        email: null,
        captcha: '',
      },
    };
  },
  validations: {
    fields: {
      email: validators.email,
      captcha: validators.captcha,
    },
  },
  computed: {
    ...mapState('app', ['systemEmails']),
    resetUrl() {
      return `${window.location.protocol}//${window.location.host}/account/password/reset/`;
    },
    resetButtonDisabled() {
      return this.invalidOrDisabled || !this.fields.captcha;
    },
  },
  methods: {
    ...mapActions('user', ['forgotPassword']),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('notifications', ['setSuccessSideNotification']),
    onSubmit() {
      if (this.formIsValid() && this.formDisable()) {
        this.forgotPassword({
          [CAPTCHA_FIELD]: this.fields.captcha,
          email: this.fields.email,
          url: this.resetUrl,
        })
          .then((data) => {
            this.formEnable();
            this.setSuccessSideNotification(data);
            this.setCurrentPopup();
          })
          .catch((error) => {
            this.attempt += 1;
            this.fields.captcha = null;
            this.formHandleErrors(error);
          });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-forgotten/account-forgotten.js